import { REHYDRATE, FLUSH } from 'redux-persist'
import { fromJS, List } from 'immutable'

import { Users } from 'store/records/users'
import { setUsersList, setMentionUser } from './actions'
import { setStory } from 'store/entities/activity/actions'
import { setCustomStory } from 'store/entities/identity/actions'

export const initialState = new Users()

const usersReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REHYDRATE: {
      return payload && payload.users ? payload.users : state
    }
    case FLUSH: {
      return new Users()
    }
    case setUsersList.success.toString(): {
      if (payload && payload.data) {
        return state.set('usersList', fromJS(payload.data))
      }
      return new Users()
    }
    case setMentionUser.toString(): {
      return state.update('mentionUsers', list => list.push(payload.user))
    }
    case setStory.success.toString(): {
      return state.set('mentionUsers', List())
    }
    case setCustomStory.success.toString(): {
      return state.set('mentionUsers', List())
    }
    default: {
      return state
    }
  }
}

export default usersReducer
